// extracted by mini-css-extract-plugin
export default {"emptyPage":"EmptyPageGrid_emptyPage__yh0yY","emptyPage__content":"EmptyPageGrid_emptyPage__content__Cjg-j","emptyPage__icon":"EmptyPageGrid_emptyPage__icon__5lNu1"};